import { useState } from "react";
import { toast } from "sonner";
import { FileText, Printer } from "lucide-react";
import { api, fmt, errMsg } from "@/lib/api";
import { useT } from "@/lib/i18n";
import { Btn, Modal } from "@/components/ui-kit";

export function PreBillButton({ rid, order, className = "", onDone }) {
  const { t } = useT();
  const [busy, setBusy] = useState(false);
  const [preview, setPreview] = useState(null);
  const run = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/restaurants/${rid}/orders/${order.id}/pre-bill`);
      if (data.printed) toast[data.agent_online ? "success" : "warning"](`${t("prebill_sent")} ${data.printer}${data.agent_online ? "" : ` · ${t("printer_err_agent_offline")}`}`);
      else setPreview(data);
      onDone?.();
    } catch (ex) { toast.error(errMsg(ex)); } finally { setBusy(false); }
  };
  return (<>
    <Btn data-testid="prebill-btn" variant="outline" className={className} disabled={busy} onClick={run}><FileText size={16} />{t("prebill")}</Btn>
    <Modal open={!!preview} onClose={() => setPreview(null)} title={t("prebill")}>
      {preview && <div data-testid="prebill-preview">
        <div className="receipt-paper mx-auto w-full max-w-xs rounded-lg border border-dashed border-slate-300 bg-white p-5 text-xs text-slate-800">
          <p className="text-center text-base font-bold uppercase">{preview.restaurant.name}</p>
          {preview.restaurant.address && <p className="text-center">{preview.restaurant.address}</p>}
          <p className="mt-2 text-center font-bold">{t("prebill_title")}</p>
          <p className="mt-2 flex justify-between"><span>{t("table")} {preview.order.table_name} · #{preview.order.number}</span><span>{preview.order.covers} {t("covers_label").toLowerCase()}</span></p>
          <div className="my-2 border-t border-dashed" />
          {preview.rows.map((r, i) => <div key={i}><p className="flex justify-between"><span>{r.qty}× {r.name}</span><span>{fmt(r.line_total)}</span></p>{r.extras.map((x) => <p key={x} className="pl-4 text-slate-500">+ {x}</p>)}</div>)}
          <div className="my-2 border-t border-dashed" />
          {preview.paid > 0 && <><p className="flex justify-between"><span>{t("subtotal")}</span><span>{fmt(preview.subtotal)}</span></p><p className="flex justify-between text-slate-500"><span>{t("already_paid")}</span><span>-{fmt(preview.paid)}</span></p></>}
          <p className="flex justify-between text-base font-extrabold"><span>{t("total")}</span><span data-testid="prebill-total">{fmt(preview.total)}</span></p>
          <p className="mt-3 text-center text-[10px] text-slate-500">{t("prebill_footer")}</p>
        </div>
        <p className="mt-3 text-center text-xs text-slate-500">{t("prebill_no_printer")}</p>
        <div className="mt-3 flex justify-end gap-2"><Btn variant="ghost" onClick={() => setPreview(null)}>{t("close")}</Btn><Btn data-testid="prebill-browser-print" onClick={() => window.print()}><Printer size={16} />{t("print_receipt")}</Btn></div>
      </div>}
    </Modal>
  </>);
}
